namespace RioERP.Masters {
    export interface AllowedDevicesRow {
        Id?: number;
        Device?: string;
    }

    export namespace AllowedDevicesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Device';
        export const localTextPrefix = 'Masters.AllowedDevices';
        export const lookupKey = 'Masters.AllowedDevices';

        export function getLookup(): Q.Lookup<AllowedDevicesRow> {
            return Q.getLookup<AllowedDevicesRow>('Masters.AllowedDevices');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Device = "Device"
        }
    }
}
